
const initialState = {
  WaveDetailsData: [],
  loading: true,
  error: null,
};

const WaveReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case "GET_WAVE_DETAILS_REQUEST":
      return {
        ...state,
        WaveDetailsData: payload,
        loading: true,
        error: null,
      };
    case "GET_WAVE_DETAILS_SUCCESS":
      return {
        ...state,
        WaveDetailsData: payload,
        loading: false,
        error: null,
      };
    case "GET_WAVE_DETAILS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default WaveReducer;
